import { Outlet, createFileRoute } from "@tanstack/react-router"
import { campaignQuery } from "@/lib/queries"

export const Route = createFileRoute("/w/$workspace/campaigns/$campaignId")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(campaignQuery(params.workspace, params.campaignId)),
  component: () => <Outlet />,
})
